import { useContext, useEffect } from "react"
import { ServerRenderedProps } from "./contexts/ServerRenderedProps"
import { Helmet } from "@dr.pogodin/react-helmet"

declare global {
  interface Window {
    pendo?: {
      initialize: (config: {
        visitor: { id: number | null; church_center_created_at?: string }
        account: {
          id: number
          org_name?: string
          church_center_created_at?: string
        }
      }) => void
    }
  }
}

const pendoApiKey = import.meta.env.VITE_PENDO_API_KEY

export function InitializePendo() {
  const { pendo: pendoData } = useContext(ServerRenderedProps)

  useEffect(() => {
    if (!pendoApiKey || !pendoData?.account?.id) return

    window.pendo?.initialize({
      visitor: {
        id: pendoData?.visitor?.id,
        ...(pendoData.visitor.church_center_created_at && {
          church_center_created_at: pendoData.visitor.church_center_created_at,
        }),
      },
      account: {
        id: pendoData.account.id,
        org_name: pendoData.account.org_name,
        church_center_created_at: pendoData.account.church_center_created_at,
      },
    })
  }, [pendoData])

  if (!pendoApiKey) return null

  return (
    <Helmet defer={false}>
      <script async>
        {`
          (function(apiKey){
            (function(p,e,n,d,o){var v,w,x,y,z;o=p[d]=p[d]||{};o._q=o._q||[];
            v=['initialize','identify','updateOptions','pageLoad','track'];for(w=0,x=v.length;w<x;++w)(function(m){
              o[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments,0)));};})(v[w]);
              y=e.createElement(n);y.async=!0;y.src='https://cdn.pendo.io/agent/static/'+apiKey+'/pendo.js';
              z=e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y,z);})(window,document,'script','pendo');
          })('${pendoApiKey}');
        `}
      </script>
    </Helmet>
  )
}
